var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'credit-card',
    ("is-" + (_vm.validatedBrand || 'unknown')),
    {
      'has-image': _vm.brandImage,
      'has-number': _vm.numberText,
    } ]},[_c(_vm.brandImage || 'div',{tag:"component",staticClass:"credit-card-brand",attrs:{"role":"image"}}),_c('div',{staticClass:"credit-card-number"},[_vm._v(_vm._s(_vm.numberText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }